import { useMutation } from '@tanstack/react-query';
import { useColorScheme } from '@mui/material/styles';
import { useAuth } from '../contexts/AuthContext';
import { authService } from '../services/api';

// Modo de cor do MUI + gravação na preferência do colaborador. A troca é
// aplicada na hora (localStorage do MUI) e salva no backend em seguida; se a
// gravação falhar, o tema continua trocado neste dispositivo. Sem colaborador
// (usuário interno sem customer) fica só no dispositivo.
export default function useColorSchemePreference() {
  const { mode, setMode } = useColorScheme();
  const { collaborator, updateCollaborator } = useAuth();

  const saveMutation = useMutation({
    mutationFn: (colorScheme) => authService.updateMyPreferences({ color_scheme: colorScheme }),
    onSuccess: (response) => updateCollaborator({ preferences: response.data }),
  });

  const changeMode = (value) => {
    setMode(value);
    if (collaborator?.uuid) saveMutation.mutate(value);
  };

  return { mode, setMode: changeMode, saveError: saveMutation.isError, resetSaveError: saveMutation.reset };
}
